import * as React from 'react'
import Loading from '@components/Loading'

const lazy = React.lazy
const Suspense = React.Suspense

function WaitingComponent(Component: any): any {
  return (props: any) => (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  )
}

function lazyLoad(Component: any): any {
  return WaitingComponent(lazy(Component))
}

export { lazyLoad}
export default lazyLoad
